export const createErrorCode = (): string => {
    if (typeof window === 'undefined') {
        return '';
    }

    const date = new Date();

    return `${date.getTime()}${location.pathname !== '/' ? location.pathname + location.search : '/999'}`;
};
